(function () {
    'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('mongo', {
                parent: 'entity',
                url: '/cache-mongo',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Cache do MongoDB'
                },
                ncyBreadcrumb: {
                    label: 'Cache do MongoDB'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/mongo/mongo.html',
                        controller: 'MongoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    });
})();
